/*
* Form View
*/

dvApp.forms = {};
dvApp.doctypes = {};
dvApp.page_fields = {};

